import { Vector2 } from 'three';

/**
 * To preserve aspect ratio and avoid distortion with orthographic camera,
 * the aspect ratio of the view frustum needs to match aspect ratio of the canvas.
 *
 * @param frustum Ortographic camera's view frustum
 * @param aspectRatio Ortographic camera's view frustum's aspect ratio to be preserved
 */
export function preserveFrustumAspectRatio(frustum: Vector2, aspectRatio: number): Vector2 {
  const adjustedFrustum = new Vector2(frustum.x, frustum.y);
  if (adjustedFrustum.x / adjustedFrustum.y !== aspectRatio) {
    if (adjustedFrustum.x / adjustedFrustum.y < aspectRatio) {
      const increase = adjustedFrustum.y * aspectRatio - adjustedFrustum.x;
      adjustedFrustum.x += increase;
    } else {
      const increase = (adjustedFrustum.x - adjustedFrustum.y * aspectRatio) / aspectRatio;
      adjustedFrustum.y += increase;
    }
  }
  return adjustedFrustum;
}
